/**
 * Reseller-admin list route — eagerly registers the file route but defers the
 * page component (design frames + `resellersAtom` read) via `.lazy.tsx`, so the
 * reseller-admin chunk stays out of the always-loaded `main` bundle.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/admin_/resellers/")({});
